import { observable, makeObservable, override } from 'mobx';
import isNil from 'lodash/isNil';

import { AbstractField } from './AbstractField';
import { store } from '@store';
import { translate } from '@chaika/i18n/helper';
import { assertIsDefined } from '@utils/assertIsDefined';

export class SwitchField extends AbstractField<boolean, boolean> {
    @observable
    private label_?: string;

    constructor(params: boolean, name: string) {
        super(params, name);
        makeObservable(this);
    }

    @override
    public get hasData(): boolean {
        return !isNil(this.fieldValue);
    }

    public makeUpdateParams() {
        return this.fieldValue;
    }

    public getPreview(): string {
        if (!this.label_) {
            this.setData();
        }

        return `${this.label_} ${translate(this.fieldValue ? 'yes' : 'no')}`;
    }

    public setData() {
        const {
            common: { fieldsParams },
        } = store;
        const fieldParams = fieldsParams.get(this.fieldName);
        assertIsDefined(fieldParams, `Field params of ${this.fieldName} are loaded with the entry type`);
        const { data } = fieldParams;

        this.label_ = data?.label ?? '';
    }

    protected setDefaultValueValue(): void {
        this.defaultNullValue = undefined;
    }

    protected setFieldValue(value: boolean) {
        this.fieldValue = value;
    }
}
